import {ApiModuleConfig, ApiRequestConfigInfoDefinitionMap} from './api.types';

export const API_ENDPOINTS: ApiRequestConfigInfoDefinitionMap = {};
export const API_CONFIG: ApiModuleConfig = {
  apiUrl: '',
  apiCode: ''
};
